import { cn } from '@/lib/utils';

import IconCircledCheck from '~/svg/IconCircledCheck.svg';
import IconCloseCircled from '~/svg/IconCloseCircled.svg';

type Props = {
  isVisible: boolean;
  status: 'success' | 'error';
};

export const ResponseStatus = ({ isVisible, status }: Props) => {
  const Icon = status === 'error' ? IconCloseCircled : IconCircledCheck;
  const message = status === 'error' ? 'Request Failed' : 'Request Successful';

  return (
    <div
      className={cn(
        'bg-neutral-dark-N90 flex h-full w-full -translate-y-full items-center justify-center gap-x-2.5 px-2.5 py-0.5 duration-300',
        status === 'error' && 'text-error-E99',
        status === 'success' && 'text-success-S99',
        isVisible && 'translate-y-0'
      )}
    >
      <Icon className='size-4' />
      <p className='text-label-text-l'>{message}</p>
    </div>
  );
};
